// @ts-nocheck
import React from "react";
import { Button, Result, Typography, } from "antd";
const { Text, Paragraph, } = Typography;

import { getLocale } from "umi";

const defaultLocale = "en-US";

export const ErrorBoundary = ({ error }: { error: any }) => {
  let currentLocale = defaultLocale;
  currentLocale = getLocale ? getLocale() : defaultLocale;
  
  const url = window.location.href.replace((window.location.origin || '') + '/#', '')

  React.useEffect(() => {
    if (window.ineum) {
      console.log('%c[Instana]%c reportError RENDER_ERROR', 'color: white; background-color: #1e88e5; padding: 2px 4px; border-radius: 3px;', 'color: #1e88e5; font-weight: bold;', error?.message);
      // console.warn('log', 'reportError', 'RENDER_ERROR');
      (window as any).ineum('reportError', new Error('RENDER_ERROR'), {
        meta: {
            position: 'slave_error_boundary',
            slaveAppName: window.__QIANKUN_APP_NAME__ || 'slave',
            url: window.location.href,
            errorMsg: error?.message,
            errorStack: error?.stack,
            errorType: error?.name,

        },
      })  
    }
  }, [])

  return (
    <Result
      status="500"
      title={
        currentLocale === defaultLocale
          ? "Whoops, something went wrong"
          : "出错了"
      }
      subTitle={
        currentLocale === defaultLocale
          ? "This page failed to load, please try again later"
          : "页面加载失败，请稍后重试"
      }
      extra={
        <div>
          <Button type="primary" onClick={() => window.location.reload()}>
            {currentLocale === defaultLocale ? "Reload" : "再试一次"}
          </Button>
          <Paragraph mark>
            {currentLocale === defaultLocale ? "pageUrl" : "页面地址"}：<Text copyable>{url}</Text>
          </Paragraph>
        </div>
      }
    />
  );
};
